<template>
	<v-app>
		<h1 style="text-align: center; padding: 15px">Rejestracja wolontariusza</h1>

		<v-dialog v-model="emailDialog" max-width="500">
			<v-card>
				<v-card-title class="headline">Podany e-mail już istnieje w systemie</v-card-title>

				<v-card-text>Na podany e-mail został już zarejestrowany użytkownik.</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="green darken-1"
						flat="flat"
						@click="emailDialog = false">
						Ok
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-stepper v-model="step" class="register-volunteer-list">
			<v-stepper-header>
				<v-stepper-step :complete="step > 0" step="1">Dane osobowe</v-stepper-step>
				<v-divider></v-divider>

				<v-stepper-step :complete="step > 1" step="2">Dane teleadresowe</v-stepper-step>
				<v-divider></v-divider>

				<v-stepper-step :complete="step > 2" step="3">Wykształcenie</v-stepper-step>
				<v-divider></v-divider>

				<v-stepper-step :complete="step > 3" step="4">Zainteresowania</v-stepper-step>
				<v-divider></v-divider>

				<v-stepper-step :complete="step > 4" step="5">Oświadczenie</v-stepper-step>
				<v-divider></v-divider>
			</v-stepper-header>

			<v-stepper-items>
				<v-stepper-content step="1">
					<StepPersonalDataComponent
						v-on:step="handleNextStep"
						v-bind:step-data="formData.firstStep"/>
				</v-stepper-content>
				<v-stepper-content step="2">
					<StepAddressDataComponent
						v-on:step="handleNextStep"
						v-bind:step-data="formData.secondStep"/>
				</v-stepper-content>
				<v-stepper-content step="3">
					<StepEducationDataComponent
						v-on:step="handleNextStep"
						v-bind:step-data="formData.thirdStep"/>
				</v-stepper-content>
				<v-stepper-content step="4">
					<StepInterestsDataComponent
						v-on:step="handleNextStep"
						v-bind:step-data="formData.fourthStep"/>
				</v-stepper-content>
				<v-stepper-content step="5">
					<StepTermsAndConditionsComponent
						v-on:step="handleNextStep"
						v-bind:step-data="formData.fifthStep"/>
				</v-stepper-content>
			</v-stepper-items>
		</v-stepper>
		<v-footer
			primary color="white"
			class="elevation-2 d-flex"
			absolute
		>
			<div class="my-3 regulation">
				<a href="/declaration.html">
					Deklaracja dostępności
				</a>
			</div>	
		</v-footer>
	</v-app>
</template>

<script>
	import StepPersonalDataComponent from "./components/StepPersonalDataComponent";
	import StepAddressDataComponent from "./components/StepAddressDataComponent";
	import StepEducationDataComponent from "./components/StepEducationDataComponent";
	import StepInterestsDataComponent from "./components/StepInterestsDataComponent";
	import StepTermsAndConditionsComponent from "./components/StepTermsAndConditionsComponent";
	import {encoder} from "@/utils/encodeHelper";
  import {UserRegister} from "@/api/generated/UserRegister";
	import {showRecaptchaBadge, hideRecaptchaBadge} from "@/utils/Recaptcha";

	export default {
		name: "RegisterVolunteer",

		components: {
			StepPersonalDataComponent,
			StepAddressDataComponent,
			StepEducationDataComponent,
			StepInterestsDataComponent,
			StepTermsAndConditionsComponent,
		},

		provide() {
			return {parentValidator: this.$validator};
		},

		created() {
			this.addRecaptcha();
		},

		beforeDestroy() {
			hideRecaptchaBadge();
		},

		methods: {
			async register() {
				if (this.formData.thirdStep.education.grade === "") {
					this.formData.thirdStep.education.grade = undefined;
				}

				await this.executeRecaptcha();
				UserRegister.postRegisterVolunteer(this, this.formData, response => {
					if (response !== undefined && response.status === "OK") {
						this.$router.push("/register-completed?email=".concat(encoder.encodeUrlParam(this.formData.firstStep.email)));
					} else {
						this.$router.push("/error");
					}
				}, errorResponse => {
					this.$messagesBus.$emit("error", "Nie udało się zarejestrować wolontariusza", errorResponse);
				});
			},

			async executeRecaptcha() {
				return new Promise((resolve, reject) => {
					if (!this.recaptchaPublicKey) {
						resolve();
						return;
					}
					// eslint-disable-next-line no-undef
					grecaptcha.enterprise.ready(() => {
						// eslint-disable-next-line no-undef
						grecaptcha.enterprise.execute(this.recaptchaPublicKey, {action: "register_volunteer"})
							.then((token) => {
								this.formData.recaptchaToken = token;
								resolve();
							})
							.catch((error) => reject(error));
					});
				});
			},

			addRecaptcha() {
				showRecaptchaBadge(this.recaptchaPublicKey);
			},

			validateEmail() {
        let emailUnique = false;
        UserRegister.getValidateUserEmailUniqueness(this, encoder.encodeUrlParam(this.formData.firstStep.email),
					response => {
						if (response.unique === false) {
							emailUnique = false;
							this.emailDialog = true;
							this.step = 1;
						} else {
							emailUnique = true;
						}
					}, errorResponse => {
              let errorMessage = errorResponse.status === "TOO_MANY_REQUESTS"
                  ? "Wykorzystano limit żądań. Odczekaj kilka minut zanim spróbujesz ponownie"
                  : "Wystąpił błąd podczas walidacji adresu e-mail";
              this.$messagesBus.$emit("error", errorMessage, errorResponse);
            });

				return emailUnique;
			},


			handleNextStep(step, scope) {
				if (step > this.step) {

					this.$validator.validateAll(scope).then(result => {
						if (step === 2 && this.validateEmail()) {
							return;
						}

						if (!result) {
							return;
						}

						if (step === 6) {
							this.register();
						} else if (result) this.step = step;
					});
				} else {
					this.step = step;
				}
			},

		},

		data() {
			return {
				step: 1,
				emailDialog: false,
				recaptchaPublicKey: process.env.VUE_APP_PUBLIC_RECAPTCHA_KEY,
				formData: {
					recaptchaToken: null,
					firstStep: {
						name: "",
						surname: "",
						email: "",
					},

					secondStep: {
						phoneNumber: "",
						address: {
							street: "",
							building: "",
							apartment: "",
							postalCode: "",
							city: "",
						},
					},

					thirdStep: {
						education: {
							grade: undefined,
							description: "",
						},
						languageList: [],
					},

					fourthStep: {
						interests: {
							description: "",
							confirmation: "",
							workingExperience: "",
							extraInformation: "",
						},
					},
					fifthStep: {
						status1: null,
						status2: null,
						status3: null,
					}
				},
			};
		},
	};
</script>

<style>
	.v-input--selection-controls .v-input__control {
		width: 100%;
	}

	.theme--dark.v-btn.v-btn--disabled {
		color: #fff !important;
	}
</style>
